var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"canvas-main"},[_c('canvas',{ref:"myCanvas",staticClass:"canvas",attrs:{"width":"330","height":"650"}})])}
var staticRenderFns = []

export { render, staticRenderFns }